import { salesFunnelService } from '../services/salesFunnel.service';

const state = {
  chartData: [],
  chartKey: 0
};

const actions = {
  getChart({ dispatch, commit }, params) {
    const formattedParams = {
      start_date: params.startDate,
      end_date: params.endDate,
      opportunity_type: params.opportunityType,
      owner_id: params.ownerId
    };

    return salesFunnelService.getData(formattedParams)
      .then(res => {
        commit('addChart', {
          data: res.data,
          params: params
        });
      })
      .catch(() => dispatch('alert/error', 'Unable to get chart data', { root: true }));
  },

  deleteChart({ commit }, chartId) {
    commit('removeChart', { chartId });
  }
};

const mutations = {
  addChart(state, payload) {
    state.chartData.unshift(Object.assign(payload.data, {id: state.chartKey}, payload.params));
    state.chartKey++;
  },

  removeChart(state, payload) {
    const index = state.chartData.find(chart => chart.id === payload.chartId);
    state.chartData.splice(index, 1);
  }
};

export const salesFunnel = {
  namespaced: true,
  state,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/salesFunnel.module.js